/**
 * List of discussion posts from users.
 */
import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import {compose} from "mu-lambda";
import * as React from "react";
import {connect} from "react-redux";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {LabelLarge} from "@khanacademy/wonder-blocks-typography";
import type {ApolloGqlClient} from "@repo/data-gql-apollo";

import type {OfficialClarification} from "#clarifications-package/types.ts";
import withApollo, {
    type WithApolloProps,
    type WithoutApollo,
} from "#data-access/gql/with-apollo.tsx";

import * as sharedStyles from "../shared-styles.ts";

import {getNextPageAction} from "./discussion-actions.ts";
import DiscussionPostAcceptedClarification from "./discussion-post-accepted-clarification.tsx";
import type {State} from "./discussion-reducer.ts";

type ReduxProps = {
    // from redux
    acceptedClarificationPosts: Array<OfficialClarification>;
    cursor: string;
    isComplete: boolean;
    onNextPage: (gqlClient: ApolloGqlClient) => void;
};

type Props = ReduxProps & WithApolloProps;

class DiscussionListAcceptedClarifications extends React.Component<Props> {
    render(): React.ReactNode {
        const {
            acceptedClarificationPosts,
            isComplete,
            cursor,
            onNextPage,
            gqlClient,
            gqlDefaultModule,
        } = this.props;

        return (
            <View>
                <View style={sharedStyles.listWrapper}>
                    <LabelLarge style={sharedStyles.clarificationsListHeader}>
                        {t`Accepted clarifications`}
                    </LabelLarge>

                    <ul>
                        {acceptedClarificationPosts.map((post) => {
                            return (
                                <li key={post.id} className={css(styles.post)}>
                                    <DiscussionPostAcceptedClarification
                                        post={post}
                                        gqlClient={gqlClient}
                                        gqlDefaultModule={gqlDefaultModule}
                                    />
                                </li>
                            );
                        })}
                    </ul>
                </View>
                {cursor && !isComplete && (
                    <Button onClick={() => onNextPage(gqlClient)}>
                        {t`Show more...`}
                    </Button>
                )}
            </View>
        );
    }
}

const styles = StyleSheet.create({
    post: {
        ...sharedStyles.postWrapper,
    },
});

const mapStateToProps = (state: State) => {
    const tab = state.tabs.clarifications;

    return {
        acceptedClarificationPosts: state.acceptedClarificationPosts,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        cursor: tab.cursor,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        isComplete: tab.isComplete,
    };
};

const mapDispatchToProps = {
    onNextPage: getNextPageAction,
} as const;

type ExportProps = WithoutApollo<
    Without<
        JSX.LibraryManagedAttributes<
            typeof DiscussionListAcceptedClarifications,
            React.ComponentProps<typeof DiscussionListAcceptedClarifications>
        >,
        ReduxProps
    >
>;

export default compose(
    withApollo,
    connect(mapStateToProps, mapDispatchToProps),
)(DiscussionListAcceptedClarifications) as React.ComponentType<ExportProps>;
